<template>
  <Card class="wayToAddHrDirectoryCard">
    <img
      :alt="title"
      class="logo-img"
      :data-test-id="$testId('ApplicationImageTag')"
      :src="logoUrl"
    >
    <div class="content">
      <HeadingExtraSmall
        class="application-name__heading"
        :hasMargin="false"
      >
        {{ title }}
      </HeadingExtraSmall>
      <div>
        <ParagraphBody
          bodySize="small"
          class="card-description"
        >
          {{ description }}
        </ParagraphBody>
        <Button
          class="configureButton"
          :data-test-id="$testId('ConfigureButton')"
          :hasOutline="true"
          :href="href"
          :isDisabled="false"
          :isExternal="isExternal"
          :isLoading="false"
          :target="isExternal ? '_blank' : undefined"
          text="Configure"
          type="secondary"
          @click="configure"
        />
      </div>
    </div>
  </Card>
</template>

<script>
import {
  Button,
  HeadingExtraSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import Card from 'client/components/Card.vue';

export default {
  name: 'WayToAddHrDirectoryCard',

  components: {
    Button,
    Card,
    HeadingExtraSmall,
    ParagraphBody,
  },

  props: {
    configure: {
      type: Function,
      default: () => {},
    },
    description: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    isExternal: Boolean,
    logoUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
@value ( jcGrey ) from '~css/brand-colors.css';

.application-name__heading {
  margin-bottom: var(--jc-spacer-x-small);
}

.card-description {
  color: var(--jcGrey);
}

.wayToAddHrDirectoryCard {
  max-width: 16rem;
  text-align: center;
}

.logo-img {
  margin-bottom: var(--jc-spacer-small);
  max-height: 50px;
  max-width: 190px;
}

.content {
  text-align: left;
}

.configureButton.configureButton {
  width: 100%;
}
</style>
